import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { flatMap, map, skip, take } from 'rxjs/operators';
import { AccountDispatcher, AccountStore } from '../store';
import {
  CHANGE_EMAIL_TOKEN_PARAMETER_KEY,
  IChangeEmailToken,
  LEGACY_CHANGE_EMAIL_TOKEN_PARAMETER_KEY,
} from '../account.data';
import { LocalizationStore } from '../../localization/store/stores';
import { isEmpty, isNull } from 'lodash';

@Injectable()
export class ChangeEmailTokenGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _accountStore: AccountStore,
    private _accountDispatchers: AccountDispatcher,
    private _localizationStore: LocalizationStore
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | UrlTree {
    // TODO: remove support for legacy token
    const token =
      route.queryParamMap.get(CHANGE_EMAIL_TOKEN_PARAMETER_KEY) ||
      route.queryParamMap.get(LEGACY_CHANGE_EMAIL_TOKEN_PARAMETER_KEY);

    if (!isEmpty(token)) {
      return this._localizationStore.getCurrentLocale().pipe(
        take(1),
        flatMap((locale: string) => {
          this._accountDispatchers.changeEmailToken(token, locale);

          return this._accountStore.getChangeEmailToken(); // get token
        }),
        skip(1),
        take(1),
        map(
          (changeToken: IChangeEmailToken) =>
            !isNull(changeToken) || this._router.parseUrl('/login')
        )
      );
    }

    return this._router.parseUrl('/login');
  }
}
